export default __webpack_public_path__ + "static/banner-5726bcc0a11d851e6f89e2f407c77402.jpg";